import { InputTextActions } from './components/input-text-actions'
import { InputTextClearButton } from './components/input-text-clear-button'
import { InputTextField } from './components/input-text-field'
import { InputTextHelperText } from './components/input-text-helpertext'
import { InputTextIcon } from './components/input-text-icon'
import { InputTextLabel } from './components/input-text-label'

import { type Scope, createContextScope } from '@radix-ui/react-context'

import { renderCompositionChildren } from './utils/render-composition-children'

import { useState } from 'react'
import type {
  InputTextContext,
  InputTextProps,
  InputTextScopedProps,
} from './input-text.types'

const DISPLAY_NAME = 'InputText'

const InputTextRoot = (props: InputTextScopedProps<InputTextProps>) => {
  const { size = 'ml', children, __scopeInputText, value } = props
  const [isActive, setActive] = useState(false)

  return (
    <InputTextProvider
      {...props}
      size={size}
      scope={__scopeInputText}
      isActive={isActive}
      value={value}
      setActive={setActive}
    >
      <div className="flex w-full flex-col gap-halfpulse ">
        {renderCompositionChildren(children, [
          { child: InputText.Label, amount: 1 },
          { child: InputText.Actions, amount: 1 },
          { child: InputText.HelperText, amount: 1 },
        ])}
      </div>
    </InputTextProvider>
  )
}

InputTextRoot.displayName = DISPLAY_NAME

/*
----------------------------------------------------------------
Scope Definition
----------------------------------------------------------------
*/

const [createInputTextContext] = createContextScope(DISPLAY_NAME)

export const [InputTextProvider, useInputTextContext]: readonly [
  ProviderType<InputTextContext>,
  (consumerName: string, scope: Scope) => InputTextContext,
] = createInputTextContext<InputTextContext>(DISPLAY_NAME)

/*
----------------------------------------------------------------
Composition Export
----------------------------------------------------------------
*/

export const InputText = {
  Root: InputTextRoot,
  Label: InputTextLabel,
  Field: InputTextField,
  HelperText: InputTextHelperText,
  Actions: InputTextActions,
  ClearButton: InputTextClearButton,
  Icon: InputTextIcon,
}
